import { createFileRoute, Outlet } from "@tanstack/react-router";

/**
 * Layout route for a single release. The album page itself lives in
 * `music.$slug.index.tsx`; song pages mount here through the Outlet.
 */
export const Route = createFileRoute("/music/$slug")({
  component: () => <Outlet />,
});
